import { DataSourcesGuard } from './data-sources.guard';

export const guards = [
  DataSourcesGuard,
];

export * from './data-sources.guard';

